export default __webpack_public_path__ + "static/media/TTC-High-Res.bcd35d9a.jpg";